<template>
    <div class="modal-conteudo-exclusivo">
        <Modal :showModal="showModal" :size="'md'" :titulo="'Conteúdo exclusivo'" :hideModal="hideModal" :name="'modal-conteudo-exclusivo'">
            <template slot="conteudo">
                <div class="row ">
                    <div class="col-12 mt-3 ">
                        <div class="d-flex flex-column w-100 align-items-center">
                            <span class="txt-h-5 txt-blue-2 text-center">
                                Faça sua assinatura e tenha acesso completo ao conteúdo.
                            </span>
                            <button class="btn btn-yellow px-5 mt-3">
                                Ver Planos
                            </button>
                        </div>

                    </div>
                    <div class="col-12 mt-3 px-5">
                        <div class="row d-flex  align-items-center px-5">
                            <div class="col-5 divisor-ou"></div>
                            <div class="col-2 d-flex justify-content-center txt-p txt-blue-2">
                                ou
                            </div>
                            <div class="col-5 divisor-ou"></div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex flex-column w-100 align-items-center">
                            <span class="txt-h-5 txt-blue-2">
                                Realize o login
                            </span>

                            <div class="row w-100 mt-2">
                                <form class="col-12" id="form-login-modal">
                                    <div class="mb-1">
                                        <input class="w-100 input-text" type="text" placeholder="Usuário" v-model="userLogin.login" required />
                                    </div>
                                    <div class="">
                                        <input class="w-100 input-text" type="password" name="senha" value="" placeholder="Senha" v-model="userLogin.password" v-on:keyup.enter="entrar" required />
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <a class="txt-h-6 txt-size-10 txt-blue-2 c-pointer" href="javascript:void(0)" @click="showModalEsqueciSenha = !showModalEsqueciSenha">Esqueci minha senha</a>
                                        </div>
                                        <div class="col-6 text-end">
                                            <a class="txt-h-6 txt-size-10 txt-blue-2 c-pointer" href="javascript:void(0)" @click="autoatendimento">Autoatendimento</a>

                                        </div>
                                    </div>
                                </form>
                                <div class="col-12 d-flex justify-content-center mt-2">
                                    <button class="btn btn-blue px-5" type="button" @click="entrar">
                                        Entrar
                                    </button>
                                </div>
                            </div>
                            <div class="row w-100">
                                <div class="col-8">
                                   
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </template>
        </Modal>

        <EsqueciMinhaSenha :showModal="showModalEsqueciSenha"></EsqueciMinhaSenha>
    </div>
    
</template>

<script>
    import Modal from '@/components/Modal';
    import EsqueciMinhaSenha from '@/components/EsqueciMinhaSenha'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalConteudoExclusivo',
        components: { Modal, EsqueciMinhaSenha},
        props: {
            logou: Function,
            showModal: {
                type: Boolean,
                required: true,
            },
            hideModal: {
                type: Boolean,
                required: true,
            }
        },
        data: function () {
            return {
                userLogin: {
                    login: "",
                    password: "",
                    Opcoes: {
                        dadosMural: false,
                    }
                },

                showModalEsqueciSenha: false,
            }
        },
        methods: {
            entrar(event) {
                event.preventDefault();
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Auth/signin`, this.userLogin)
                        .then(res => {
                            if (res.data.token.authenticated) {
                                res.data.token.usuario = res.data.usuario;
                                res.data.token.usuario.idContrato = res.data.idContrato;
                                res.data.token.usuario.tpPessoa = res.data.tpPessoa;
                                res.data.token.usuario.flCortesia = res.data.flCortesia;
                                $this.$store.commit('setUser', res.data.token);
                                $this.logou();
                            } else {
                                avisoErro("Erro ao realizar login.");
                            }
                        })
                        .catch(function () {
                            avisoErro("Login e/ou senha inválidos.");
                        })
                }

                return false;
            },


            checkForm() {
                var form = document.getElementById('form-login-modal')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            autoatendimento() {
                document.getElementById('blip-chat-icon').click();
            },
        },
        created: function () {
            
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .divisor-ou{
        border-top: 1px solid color('blue','2');
    }
</style>

